import AsyncStorage from '@react-native-async-storage/async-storage';
import { axiosinstance } from '../axiosClient';
import useAuth from './useAuth';
import { useCallback } from 'react';
import type { RefreshOutcome } from '../utils/refreshManager';
import { clearAuthFailure } from '../utils/attachAuthInterceptors';

const useRefresh = () => {
  const { auth, setAuth } = useAuth();
  const refresh = useCallback(async (): Promise<RefreshOutcome> => {
    try {
      const refreshToken = await AsyncStorage.getItem('refreshToken');
      if (!refreshToken) {
        return { kind: 'rejected' };
      }
      const response = await axiosinstance.post(
        `bp_refresh_token_information/${refreshToken}`,
        undefined,
        {
          headers: { Authorization: 'Bearer ' + auth?.accessToken },
        },
      );
      if (response.data.status === 200) {
        setAuth({
          accessToken: response?.data?.accessToken,
          refreshToken: response?.data?.refreshToken,
        });
        if (response?.data?.accessToken) {
          await AsyncStorage.setItem('accessToken', response.data.accessToken);
        }
        await AsyncStorage.setItem(
          'refreshToken',
          response?.data?.refreshToken,
        );
        clearAuthFailure('pos');
        return { kind: 'success', accessToken: response.data.accessToken };
      } else {
        return { kind: 'rejected' };
      }
    } catch (error: any) {
      if (error?.response) {
        return { kind: 'rejected' };
      }
      return { kind: 'unreachable' };
    }
  }, [auth?.accessToken, setAuth]);
  return refresh;
};

export default useRefresh;
